import { PatientActionHistoryActionInsiDetails } from '@saas/interfaces/graphql'
import { create } from 'zustand'

type State = {
    stackedDetails: PatientActionHistoryActionInsiDetails[]
}

type Actions = {
    updateStore: (state: Partial<State>) => void
    stackDetails: (value: PatientActionHistoryActionInsiDetails | PatientActionHistoryActionInsiDetails[]) => void
}

export const useInsiStore = create<State & Actions>((set) => ({
    stackedDetails: [],
    updateStore: (state) =>
        set((store) => ({
            ...store,
            ...state,
        })),
    stackDetails: (value) =>
        set((store) => {
            if (Array.isArray(value)) {
                store.stackedDetails.concat(value)
            } else {
                store.stackedDetails.push(value)
            }

            return store
        }),
}))
